import { render, staticRenderFns } from "./GerenciarFisioterapeutas.vue?vue&type=template&id=b6a03c5a&scoped=true"
import script from "./GerenciarFisioterapeutas.vue?vue&type=script&lang=js"
export * from "./GerenciarFisioterapeutas.vue?vue&type=script&lang=js"
import style0 from "./GerenciarFisioterapeutas.vue?vue&type=style&index=0&id=b6a03c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a03c5a",
  null
  
)

export default component.exports